import { NAV_OPENED } from './types';

export const navOpened = state => ({
    type: NAV_OPENED,
    payload: {
        opened: state
    }
});
